
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bM9UF", function(module, exports) {
/* ContentReportTableMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

/**
 * @generated SignedSource<<2ae160d085c710b19f9f6b8dfd00f340>>
 * @relayHash ee86c78537c1355af4f72c5f50c1f303
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fdf55a6a9a3f4540591340bc11bb50d456ae16e3f89daea15313a6e0b1c373
const $5dec3a818114e508$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeComments"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeLikes"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ], v10 = {
        "condition": "includeComments",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": v9 /*: any*/ 
            }
        ]
    }, v11 = {
        "condition": "includeLikes",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "LikesResponse",
                "kind": "LinkedField",
                "name": "likes",
                "plural": false,
                "selections": v9 /*: any*/ 
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentReportTableDataQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentReportTableDataQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ee86c78537c1355af4f72c5f50c1f303",
            "id": "24fdf55a6a9a3f4540591340bc11bb50d456ae16e3f89daea15313a6e0b1c373",
            "metadata": {},
            "name": "useContentReportTableDataQuery",
            "operationKind": "query",
            "text": "query useContentReportTableDataQuery($cql:String!,$first:Int,$includeComments:Boolean!,$includeLikes:Boolean!){search:confluence_search(cql:$cql,first:$first){nodes{title,url,lastModified,content{id,type,creatorId,history{createdBy{__typename,displayName}},comments@include(if:$includeComments){count},likes@include(if:$includeLikes){count},space{key,id}}}}}"
        }
    };
}();
$5dec3a818114e508$var$node.hash = "5091664a9f54a927ae78ac6ba80de437";
var $5dec3a818114e508$export$2e2bcd8739ae039 = $5dec3a818114e508$var$node;






var $jMyy4 = parcelRequire("jMyy4");


var $eZ4zi = parcelRequire("eZ4zi");


var $1NBp8 = parcelRequire("1NBp8");

const $87b0ed3e0116385b$var$CONTEXT_PATH = '/wiki';
const $87b0ed3e0116385b$export$195efb08db4057de = ({ labels: labels, spaces: spaces })=>{
    return (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
        query: {
            product: 'confluence',
            labels: labels.join(','),
            ...spaces.length > 0 && {
                spaces: spaces.join(',')
            }
        }
    });
};
const $87b0ed3e0116385b$export$a24513f6f013fb93 = ({ hasBlueprintExperience: hasBlueprintExperience, contentBlueprintId: contentBlueprintId, spaceKey: spaceKey })=>{
    if (!hasBlueprintExperience || !contentBlueprintId || !spaceKey) return undefined;
    return (0, $1NBp8.CREATE_PAGE).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages'
    }, {
        query: {
            blueprintModuleCompleteKey: contentBlueprintId
        }
    });
};
const $87b0ed3e0116385b$export$348f747d76f9541d = (accountId)=>`${$87b0ed3e0116385b$var$CONTEXT_PATH}/people/${accountId}?ref=confluence`;
function $87b0ed3e0116385b$export$b3c1237483f9e58(url) {
    if (!url) return null;
    if (/^https?:\/\//i.test(url) || url.startsWith($87b0ed3e0116385b$var$CONTEXT_PATH)) return url;
    if (url.startsWith('/')) return `${$87b0ed3e0116385b$var$CONTEXT_PATH}${url}`;
    return `${$87b0ed3e0116385b$var$CONTEXT_PATH}/${url}`;
}





const $bfa1cd3545b967c7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    anonymous: {
        id: "content-report-table-macro.anonymous",
        defaultMessage: "Anonymous"
    }
});
function $bfa1cd3545b967c7$export$37cd01bf27f5014b(displayName, intl) {
    if (!displayName) return intl.formatMessage($bfa1cd3545b967c7$export$defe85febe8b728c.anonymous);
    const normalized = displayName.replace(/\s*\(Deactivated\)$/i, '').trim();
    return normalized || intl.formatMessage($bfa1cd3545b967c7$export$defe85febe8b728c.anonymous);
}


const $860800497ca57abf$var$formatLastModified = (lastModified, intl)=>{
    if (!lastModified) return '';
    const timestamp = new Date(lastModified).getTime();
    if (Number.isNaN(timestamp)) return lastModified;
    return (0, $eZ4zi.formatContentReportEpochTime)(timestamp, intl);
};
function $860800497ca57abf$export$d6b72c9486242755(node, intl) {
    const normalizedUrl = (0, $87b0ed3e0116385b$export$b3c1237483f9e58)(node.url);
    if (!node.content || !node.title || !normalizedUrl) return null;
    return {
        id: node.content.id,
        title: node.title,
        url: normalizedUrl,
        lastModified: $860800497ca57abf$var$formatLastModified(node.lastModified, intl),
        creatorAccountId: node.content.creatorId ?? null,
        creatorDisplayName: (0, $bfa1cd3545b967c7$export$37cd01bf27f5014b)(node.content.history?.createdBy?.displayName, intl),
        commentCount: node.content.comments?.count ?? 0,
        likeCount: node.content.likes?.count ?? 0,
        spaceKey: node.content.space?.key ?? ''
    };
}


const $9c427d76ca038503$export$dd93ee0eb2e53674 = (params)=>{
    const intl = (0, $aXWIB.useIntl)();
    const { cql: cql, first: first, includeComments: includeComments, includeLikes: includeLikes } = params;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $5dec3a818114e508$export$2e2bcd8739ae039), {
        variables: {
            cql: cql,
            first: first,
            includeComments: includeComments,
            includeLikes: includeLikes
        },
        skip: !cql,
        __callerPackage__: "@confluence/content-report-table-macro"
    });
    if (!data) return {
        items: undefined,
        loading: loading ?? false,
        error: error ?? null
    };
    const nodes = data.search?.nodes ?? [];
    const items = [];
    for (const node of nodes){
        const item = (0, $860800497ca57abf$export$d6b72c9486242755)(node, intl);
        if (item !== null) items.push(item);
    }
    return {
        items: items,
        loading: loading ?? false,
        error: error ?? null
    };
};





const $d5626d142d565a1a$var$MAX_RESULTS_CAP = 500;
const $d5626d142d565a1a$var$DEFAULT_MAX_RESULTS = 20;
const $d5626d142d565a1a$var$CURRENT_SPACE_KEY_TOKEN = 'currentSpace()';
var $d5626d142d565a1a$export$9c8b9f8fac4b24ab = /*#__PURE__*/ function(SortOption) {
    SortOption["Modified"] = "lastModified";
    SortOption["Created"] = "created";
    SortOption["Title"] = "title";
    return SortOption;
}({});
// BE sends long-form enum values; normalise to CQL field names
const $d5626d142d565a1a$var$SORT_PARAM_TO_CQL = {
    'Page modified': "lastModified",
    modified: "lastModified",
    'Page created': "created",
    created: "created",
    'Page title': "title",
    title: "title"
};
function $d5626d142d565a1a$var$splitTrimToArray(str) {
    if (!str || str.trim() === '') return [];
    return str.split(/\s*,\s*/).filter((s)=>s.length > 0);
}
function $d5626d142d565a1a$var$parseBoolean(value, defaultValue) {
    if (value === undefined || value === '') return defaultValue;
    return value === 'true';
}
function $d5626d142d565a1a$var$parseMaxResults(value) {
    if (value === undefined || value === '') return $d5626d142d565a1a$var$DEFAULT_MAX_RESULTS;
    const parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed <= 0) return $d5626d142d565a1a$var$DEFAULT_MAX_RESULTS;
    return Math.min(parsed, $d5626d142d565a1a$var$MAX_RESULTS_CAP);
}
function $d5626d142d565a1a$var$parseSortOption(value) {
    if (!value) return "lastModified";
    return $d5626d142d565a1a$var$SORT_PARAM_TO_CQL[value] ?? "lastModified";
}
function $d5626d142d565a1a$var$buildCql(labels, spaces, sort, reverse) {
    if (labels.length === 0) return '';
    const labelClause = `label in (${labels.map((l)=>`"${l}"`).join(',')})`;
    const typeClause = `type in (page,blogpost)`;
    const parts = [
        labelClause,
        typeClause
    ];
    if (spaces.length > 0) {
        const spaceClause = `space in (${spaces.map((s)=>`"${s}"`).join(',')})`;
        parts.push(spaceClause);
    }
    const direction = reverse ? 'desc' : 'asc';
    const orderClause = `ORDER BY ${sort} ${direction}`;
    return `${parts.join(' AND ')} ${orderClause}`;
}
function $d5626d142d565a1a$export$8f0d03faf499ec50(macroParams, currentSpaceKey) {
    const rawLabels = macroParams?.labels?.value;
    const rawSpaces = macroParams?.spaces?.value;
    const labels = $d5626d142d565a1a$var$splitTrimToArray(rawLabels);
    const spaces = $d5626d142d565a1a$var$splitTrimToArray(rawSpaces).map((s)=>s === $d5626d142d565a1a$var$CURRENT_SPACE_KEY_TOKEN ? currentSpaceKey ?? s : s);
    const sort = $d5626d142d565a1a$var$parseSortOption(macroParams?.sort?.value);
    const reverse = $d5626d142d565a1a$var$parseBoolean(macroParams?.reverse?.value, true);
    const maxResults = $d5626d142d565a1a$var$parseMaxResults(macroParams?.maxResults?.value);
    const showCommentsCount = $d5626d142d565a1a$var$parseBoolean(macroParams?.showCommentsCount?.value, false);
    const showLikesCount = $d5626d142d565a1a$var$parseBoolean(macroParams?.showLikesCount?.value, false);
    const cql = $d5626d142d565a1a$var$buildCql(labels, spaces, sort, reverse);
    return {
        cql: cql,
        first: maxResults,
        includeComments: showCommentsCount,
        includeLikes: showLikesCount
    };
}
function $d5626d142d565a1a$export$2f9066b0466085e(macroParams) {
    return (0, $42omo.useMemo)(()=>{
        const rawLabels = macroParams?.labels?.value;
        const rawSpaces = macroParams?.spaces?.value;
        const currentSpaceKey = macroParams?.currentSpaceKey;
        const labels = $d5626d142d565a1a$var$splitTrimToArray(rawLabels);
        const spaces = $d5626d142d565a1a$var$splitTrimToArray(rawSpaces).map((s)=>s === $d5626d142d565a1a$var$CURRENT_SPACE_KEY_TOKEN ? currentSpaceKey ?? s : s);
        const labelsError = labels.length === 0;
        const sort = $d5626d142d565a1a$var$parseSortOption(macroParams?.sort?.value);
        const reverse = $d5626d142d565a1a$var$parseBoolean(macroParams?.reverse?.value, true);
        const maxResults = $d5626d142d565a1a$var$parseMaxResults(macroParams?.maxResults?.value);
        const showCommentsCount = $d5626d142d565a1a$var$parseBoolean(macroParams?.showCommentsCount?.value, false);
        const showLikesCount = $d5626d142d565a1a$var$parseBoolean(macroParams?.showLikesCount?.value, false);
        const blankTitle = macroParams?.blankTitle?.value ?? '';
        const blankDescription = macroParams?.blankDescription?.value ?? '';
        const contentBlueprintId = macroParams?.contentBlueprintId?.value ?? '';
        const blueprintModuleCompleteKey = macroParams?.blueprintModuleCompleteKey?.value ?? '';
        const createButtonLabel = macroParams?.createButtonLabel?.value ?? '';
        const cql = $d5626d142d565a1a$var$buildCql(labels, spaces, sort, reverse);
        const macroParamsForQuery = {
            cql: cql,
            first: maxResults,
            includeComments: showCommentsCount,
            includeLikes: showLikesCount
        };
        return {
            labels: labels,
            spaces: spaces,
            cql: cql,
            maxResults: maxResults,
            showCommentsCount: showCommentsCount,
            showLikesCount: showLikesCount,
            blankTitle: blankTitle,
            blankDescription: blankDescription,
            contentBlueprintId: contentBlueprintId,
            blueprintModuleCompleteKey: blueprintModuleCompleteKey,
            createButtonLabel: createButtonLabel,
            labelsError: labelsError,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams
    ]);
}





const $5d559771d6fec183$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    headingTitle: {
        id: "content-report-table-macro.heading.title",
        defaultMessage: "Title"
    },
    headingCreator: {
        id: "content-report-table-macro.heading.creator",
        defaultMessage: "Creator"
    },
    headingModified: {
        id: "content-report-table-macro.heading.modified",
        defaultMessage: "Modified"
    },
    headingSocial: {
        id: "content-report-table-macro.heading.social",
        defaultMessage: "Activity"
    },
    noResults: {
        id: "content-report-table-macro.no.results",
        defaultMessage: "No content found."
    },
    findMoreResults: {
        id: "content-report-table-macro.find.more.results",
        defaultMessage: "Find more results"
    },
    anonymous: {
        id: "content-report-table-macro.anonymous",
        defaultMessage: "Anonymous"
    },
    error: {
        id: "content-report-table-macro.error",
        defaultMessage: "An error occurred while loading the content report table."
    },
    errorLabelsRequired: {
        id: "content-report-table-macro.error.labels.required",
        defaultMessage: "'labels' parameter is required."
    },
    comments: {
        id: "content-report-table-macro.comments",
        defaultMessage: "{count} {count, plural, one {comment} other {comments}}"
    },
    likes: {
        id: "content-report-table-macro.likes",
        defaultMessage: "{count} {count, plural, one {like} other {likes}}"
    },
    createButton: {
        id: "content-report-table-macro.create.button",
        defaultMessage: "Create"
    }
});










var $auNCB = parcelRequire("auNCB");



var $eyWa4 = parcelRequire("eyWa4");


var $1RqgI = parcelRequire("1RqgI");











var $iXCQx = parcelRequire("iXCQx");



const $ed64b27868be6708$export$3854efb64e2f2baa = ({ accountId: accountId, displayName: displayName, canViewProfiles: canViewProfiles })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $5d559771d6fec183$export$a7357cdd1f0b0168).anonymous));
    if (canViewProfiles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: (0, $87b0ed3e0116385b$export$348f747d76f9541d)(accountId),
        target: "_blank",
        rel: "noopener noreferrer"
    }, displayName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, displayName);
};


/* SocialCell.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1yB28 = parcelRequire("1yB28");


var $9FnLD = parcelRequire("9FnLD");




var $u9agA = parcelRequire("u9agA");


const $21c5d0d31441c194$var$styles = {
    socialItem: "_syazazsu",
    count: "_11c8wadc"
};
const $21c5d0d31441c194$export$4bee26ef0d3e61ac = ({ commentCount: commentCount, likeCount: likeCount, showCommentsCount: showCommentsCount, showLikesCount: showLikesCount })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, showCommentsCount && commentCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $21c5d0d31441c194$var$styles.socialItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: formatMessage((0, $5d559771d6fec183$export$a7357cdd1f0b0168).comments, {
            count: commentCount
        }),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $21c5d0d31441c194$var$styles.count
    }, commentCount)), showLikesCount && likeCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $21c5d0d31441c194$var$styles.socialItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: formatMessage((0, $5d559771d6fec183$export$a7357cdd1f0b0168).likes, {
            count: likeCount
        }),
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $21c5d0d31441c194$var$styles.count
    }, likeCount)));
};


const $6a0411314329e867$export$f18441ab7e6b07dd = ({ items: items, hasSocialColumn: hasSocialColumn, showCommentsCount: showCommentsCount, showLikesCount: showLikesCount, canViewProfiles: canViewProfiles, showMoreResultsUrl: showMoreResultsUrl, macroId: macroId })=>{
    const head = (0, $42omo.useMemo)(()=>({
            cells: [
                {
                    key: 'title',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).headingTitle)
                },
                {
                    key: 'creator',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).headingCreator)
                },
                {
                    key: 'modified',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).headingModified)
                },
                ...hasSocialColumn ? [
                    {
                        key: 'social',
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).headingSocial)
                    }
                ] : []
            ]
        }), [
        hasSocialColumn
    ]);
    const rows = (0, $42omo.useMemo)(()=>items.map((item)=>({
                key: item.id,
                testId: `content-report-row-${item.id}`,
                cells: [
                    {
                        key: 'title',
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                            href: item.url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, item.title)
                    },
                    {
                        key: 'creator',
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed64b27868be6708$export$3854efb64e2f2baa), {
                            accountId: item.creatorAccountId,
                            displayName: item.creatorDisplayName,
                            canViewProfiles: canViewProfiles
                        })
                    },
                    {
                        key: 'modified',
                        content: item.lastModified
                    },
                    ...hasSocialColumn ? [
                        {
                            key: 'social',
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $21c5d0d31441c194$export$4bee26ef0d3e61ac), {
                                commentCount: item.commentCount,
                                likeCount: item.likeCount,
                                showCommentsCount: showCommentsCount,
                                showLikesCount: showLikesCount
                            })
                        }
                    ] : []
                ]
            })), [
        items,
        hasSocialColumn,
        showCommentsCount,
        showLikesCount,
        canViewProfiles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0",
        testId: "content-report-table-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        "data-fabric-macro": macroId,
        "data-macro-body": "",
        testId: "content-report-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1RqgI.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    })), showMoreResultsUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: showMoreResultsUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        testId: "content-report-table-more-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).findMoreResults))));
};


/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 













const $6045b272827c229d$var$styles = {
    container: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1rjcutpp _18zrutpp",
    heading: "_11c8fhey _1mouze3t _syaz1rpy _k48p1pd9",
    message: "_1mouze3t _syaz1rpy",
    createButton: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8fhey _1rjc12x7 _18zrutpp _1e0c1o8l _1pfhu2gc _bfhk1856 _syaz15cr _k48p1wq8"
};
const $6045b272827c229d$export$fddf379e22a74b00 = ({ blankTitle: blankTitle, blankDescription: blankDescription, createButtonLabel: createButtonLabel, createContentUrl: createContentUrl, hasBlueprintExperience: hasBlueprintExperience })=>{
    if (hasBlueprintExperience && blankTitle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6045b272827c229d$var$styles.container,
        testId: "content-report-table-blueprint-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6045b272827c229d$var$styles.heading,
        as: "h2"
    }, blankTitle), blankDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6045b272827c229d$var$styles.message,
        as: "p"
    }, blankDescription), createButtonLabel && createContentUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: createContentUrl,
        xcss: $6045b272827c229d$var$styles.createButton
    }, createButtonLabel)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6045b272827c229d$var$styles.container,
        testId: "content-report-table-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6045b272827c229d$var$styles.message,
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).noResults)));
};


const $4698c3a5a3112101$var$styles = {
    loadingContainer: "_1rjc1ejb _1e0c1txw _1bah1h6o"
};
const $4698c3a5a3112101$var$ContentReportTableMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, canViewProfiles: canViewProfiles = true })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { labels: labels, spaces: spaces, maxResults: maxResults, showCommentsCount: showCommentsCount, showLikesCount: showLikesCount, blankTitle: blankTitle, blankDescription: blankDescription, contentBlueprintId: contentBlueprintId, blueprintModuleCompleteKey: blueprintModuleCompleteKey, createButtonLabel: createButtonLabel, labelsError: labelsError, macroParamsForQuery: macroParamsForQuery } = (0, $d5626d142d565a1a$export$2f9066b0466085e)(macroParams);
    const { items: items, loading: loading, error: error } = (0, $9c427d76ca038503$export$dd93ee0eb2e53674)(macroParamsForQuery);
    if (labelsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: new Error(formatMessage((0, $5d559771d6fec183$export$a7357cdd1f0b0168).errorLabelsRequired))
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (loading || items === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4698c3a5a3112101$var$styles.loadingContainer,
        testId: "content-report-table-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium",
        label: "Loading content report table"
    }));
    const hasBlueprintExperience = items.length === 0 && Boolean(blueprintModuleCompleteKey);
    if (items.length === 0) {
        // Build create content URL for blueprint blank experience
        const createContentUrl = (0, $87b0ed3e0116385b$export$a24513f6f013fb93)({
            hasBlueprintExperience: hasBlueprintExperience,
            contentBlueprintId: contentBlueprintId,
            spaceKey: macroDefaultProps.spaceKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6045b272827c229d$export$fddf379e22a74b00), {
            blankTitle: blankTitle,
            blankDescription: blankDescription,
            createButtonLabel: createButtonLabel,
            createContentUrl: createContentUrl,
            hasBlueprintExperience: hasBlueprintExperience
        });
    }
    const hasSocialColumn = showCommentsCount || showLikesCount;
    const showMoreResults = items.length >= maxResults; // Build "Find more results" URL
    const showMoreResultsUrl = showMoreResults ? (0, $87b0ed3e0116385b$export$195efb08db4057de)({
        labels: labels,
        spaces: spaces
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a0411314329e867$export$f18441ab7e6b07dd), {
        items: items,
        hasSocialColumn: hasSocialColumn,
        showCommentsCount: showCommentsCount,
        showLikesCount: showLikesCount,
        canViewProfiles: canViewProfiles,
        showMoreResultsUrl: showMoreResultsUrl,
        macroId: macroDefaultProps?.attributes?.macroId ? String(macroDefaultProps.attributes.macroId) : undefined
    });
};
const $4698c3a5a3112101$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d559771d6fec183$export$a7357cdd1f0b0168).error);
const $4698c3a5a3112101$export$7adc083955fe089c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $4698c3a5a3112101$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4698c3a5a3112101$var$ContentReportTableMacroRendererComponent, props));
};
module.exports["ContentReportTableMacroRenderer"] = $4698c3a5a3112101$export$7adc083955fe089c;

});

parcelRegister("eZ4zi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $aXWIB.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});

parcelRegister("1RqgI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $dplWX = parcelRequire("dplWX");


var $gEpEw = parcelRequire("gEpEw");

class $f76d2aa2a1b6bce3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gEpEw.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $dplWX.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}
$f76d2aa2a1b6bce3$export$2e2bcd8739ae039.defaultProps = {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $ee7An.default),
    onSort: (0, $ee7An.default),
    rowsPerPage: Infinity
};
module.exports["default"] = $f76d2aa2a1b6bce3$export$2e2bcd8739ae039;

});

parcelRegister("dplWX", function(module, exports) {

var $52yvm = parcelRequire("52yvm");

const $843c9fb348cdf4f4$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = (0, $52yvm.computeIndex)(sourceIndex, page, rowsPerPage);
    const toIndex = (0, $52yvm.computeIndex)(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};
module.exports["reorderRows"] = $843c9fb348cdf4f4$export$c476bbe5da59992d;

});

parcelRegister("52yvm", function(module, exports) {
const $034ab513bf2ba5a6$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
module.exports["computeIndex"] = $034ab513bf2ba5a6$export$92bcb1ed38b134a1;

});


//# sourceMappingURL=ContentReportTableMacroRenderer.fa46ea36.js.map
